import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export const DotsVerticalIcon: FC<IconProps> = ({ className, iconColor = '#344054', ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33331 8.00065C7.33331 8.17746 7.40355 8.34703 7.52858 8.47206C7.6536 8.59708 7.82317 8.66732 7.99998 8.66732C8.17679 8.66732 8.34636 8.59708 8.47138 8.47206C8.59641 8.34703 8.66665 8.17746 8.66665 8.00065C8.66665 7.82384 8.59641 7.65427 8.47138 7.52925C8.34636 7.40422 8.17679 7.33398 7.99998 7.33398C7.82317 7.33398 7.6536 7.40422 7.52858 7.52925C7.40355 7.65427 7.33331 7.82384 7.33331 8.00065Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M7.33333 12.6667C7.33333 12.8435 7.40357 13.013 7.5286 13.1381C7.65362 13.2631 7.82319 13.3333 8 13.3333C8.17681 13.3333 8.34638 13.2631 8.4714 13.1381C8.59643 13.013 8.66667 12.8435 8.66667 12.6667C8.66667 12.4899 8.59643 12.3203 8.4714 12.1953C8.34638 12.0702 8.17681 12 8 12C7.82319 12 7.65362 12.0702 7.5286 12.1953C7.40357 12.3203 7.33333 12.4899 7.33333 12.6667Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M7.33331 3.33268C7.33331 3.50949 7.40355 3.67906 7.52858 3.80409C7.6536 3.92911 7.82317 3.99935 7.99998 3.99935C8.17679 3.99935 8.34636 3.92911 8.47138 3.80409C8.59641 3.67906 8.66665 3.50949 8.66665 3.33268C8.66665 3.15587 8.59641 2.9863 8.47138 2.86128C8.34636 2.73625 8.17679 2.66602 7.99998 2.66602C7.82317 2.66602 7.6536 2.73625 7.52858 2.86128C7.40355 2.9863 7.33331 3.15587 7.33331 3.33268Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
